import { useCartContext } from "app/providers/CartProvider";
import Card from "shared/ui/card";
import CheckoutPanelDatePicker from "widgets/checkout/standard-product-date-picker";
import CheckoutPanelDatePickerHeader from "entities/checkout/standard-product-date-picker-header";
import CheckoutPanelShipmentDeliveryDatePicker from "widgets/checkout/standard-product-date-picker/standard-product-shipment-delivery-date-picker";
import CheckoutPanelCalendarFooter from "widgets/checkout/checkout-panel-calendar-footer";
import { STORAGE_ORDER_KEY } from "shared/config";
import { useCallback, useMemo } from "react";
import { getLocalDateString } from "shared/utils/date";

const CheckoutCalendar = () => {
  const { getCart, updateGeneralCartValue } = useCartContext();
  const cart = getCart();
  const showShipmentDeliveryCalendar = !cart.pickupWarehouse;
  const key = !cart.pickupWarehouse
    ? cart.withAssembly
      ? "shipment"
      : "delivery"
    : "";

  const orderDeliveryType =
    !cart.withAssembly && !cart.pickupWarehouse ? "shipment" : "placement";

  const order_id = localStorage.getItem(STORAGE_ORDER_KEY) ?? "";

  //Stable reference to set date function
  const setDate = useCallback(
    (date: Date | null) => {
      updateGeneralCartValue({
        ...cart,
        delivery: {
          ...cart.delivery,
          date: date,
        },
      });
    },
    [cart, updateGeneralCartValue],
  );

  // SelectedDate
  const selectedDateProp = cart.delivery.date
    ? new Date(cart.delivery.date)
    : null;

  // Format the date
  const formattedDate = useMemo(() => {
    return cart.delivery.date
      ? getLocalDateString(new Date(cart.delivery.date))
      : "Geen datum gekozen";
  }, [cart.delivery.date]);

  return (
    <>
      <Card
        className="gg-border-b gg-border-t gg-px-4 sm:gg-px-14 2xl:gg-px-32"
        shadow={false}
      >
        <section className="gg-grid gg-grid-cols-12">
          <>
            {/* {!productAnalysis.someAkoestischepanelen && ( */}
            <div className="gg-col-span-12 gg-grid gg-grid-cols-12 gg-border-t gg-py-14">
              <CheckoutPanelDatePickerHeader className="gg-col-span-12 gg-mb-10 lg:gg-col-span-4 lg:gg-mb-0 lg:gg-pr-10 xl:gg-pr-24" />
              {/* starts from today */}
              {showShipmentDeliveryCalendar ? (
                <CheckoutPanelShipmentDeliveryDatePicker
                  order_id={order_id}
                  key={key}
                  bumbalType={orderDeliveryType}
                  setDate={setDate}
                  selectedDateProp={selectedDateProp}
                  formattedDate={formattedDate}
                />
              ) : (
                // Starts from april 2
                <CheckoutPanelDatePicker className="gg-col-span-12 lg:gg-col-span-8" />
              )}
            </div>
            {/* )} */}
          </>
        </section>
      </Card>
      <CheckoutPanelCalendarFooter />
    </>
  );
};
export default CheckoutCalendar;
